<template>
  <div class="list">
    <ul v-if="listData.length > 0">
      <li
        v-for="(item, index) in listData"
        :key="item.yjsgkid"
        @click="fileClick(item)"
        :class="{ 'first-div': index === 0 }"
      >
        <div class="dian"></div>
        <div class="list_txt" @click="gotoDetail(item)">
          {{ item.title }}
        </div>
        <p class="list_time">
          {{ item.showtime.split(" ")[0] }}
        </p>
      </li>
    </ul>
    <ul v-else>
      <li>
        <div class="list_txt">
          <!-- 暂无数据 -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'normalList',
  props: {
    listData: {
      type: Array
    },
    place: {
      type: String
    },
    deptList: {
      type: Number
    },
    classinfoid: {
      type: String
    },
    year: {
      type: String
    }
  },
  data () {
    return {
      fileType: ''
    }
  },
  watch: {
    classinfoid (val, old) {
      this.fileType = val
      // console.log( this.fileType)
    }
  },
  mounted () {
    // console.log(this.fileType)
  },
  methods: {
    // 详情页，新开页
    gotoDetail (item) {
      // var objfile=encodeURIComponent(JSON.stringify(item))
      if (item) {
        var url =
          location.origin +
          '/#/detailsPage' +
          '?id=' +
          item.metaDataId +
          '&areaName=' +
          this.place +
          '&deptname=' +
          item.deptname +
          '&classinfoid=' +
          this.$route.query.classinfoid +
          '&year=' +
          this.year
        window.open(url, '_blank')
      }
    },
    fileClick (item) {
      var dwvalue = localStorage.getItem('ISdwname')
      // console.log(this.year)

      if (this.year == '自定义') {
        this.year = localStorage.getItem('rangeyear')
      }
      if (this.deptList == 1 && dwvalue != 1) {
        this.$http
          .post('/yjsUbas/yjs/add', {
            browserVersion: navigator.appVersion,
            browserName: navigator.appName,
            browserLanguage: navigator.language,
            areaCode: item.areacode,
            areaName: this.place,
            deptCode: item.deptcode,
            deptName: item.deptname,
            unitCode: '',
            unitName: '',
            areaYear: this.year,
            sourceType: 4,
            fileType: this.$route.query.classinfoid,
            docId: item.fileList[0].appdocid,
            title: item.title,
            channelId: item.channelId,
            url:
              location.origin +
              '/#/detailsPage' +
              '?id=' +
              item.metaDataId +
              '&areaName=' +
              this.place +
              '&deptname=' +
              item.deptname +
              '&classinfoid=' +
              this.$route.query.classinfoid +
              '&year=' +
              this.year
          })
          .then((res) => {
            // if (res.data.code === 200) {
            // this.listData = res.data.data
          })
      } else if (this.deptList == 1 && dwvalue == 1) {
        this.$http
          .post('/yjsUbas/yjs/add', {
            browserVersion: navigator.appVersion,
            browserName: navigator.appName,
            browserLanguage: navigator.language,
            areaCode: item.areacode,
            areaName: this.place,
            deptCode: localStorage.getItem('bmcode'),
            deptName: localStorage.getItem('bmname'),
            unitCode: item.deptcode,
            unitName: item.deptname,
            areaYear: this.year,
            sourceType: 4,
            fileType: this.$route.query.classinfoid,
            docId: item.fileList[0].appdocid,
            title: item.title,
            channelId: item.channelId,
            url:
              location.origin +
              '/#/detailsPage' +
              '?id=' +
              item.metaDataId +
              '&areaName=' +
              this.place +
              '&deptname=' +
              item.deptname +
              '&classinfoid=' +
              this.$route.query.classinfoid +
              '&year=' +
              this.year
          })
          .then((res) => {})
      } else {
        this.$http
          .post('/yjsUbas/yjs/add', {
            browserVersion: navigator.appVersion,
            browserName: navigator.appName,
            browserLanguage: navigator.language,
            areaCode: item.areacode,
            areaName: this.place,
            deptCode: '',
            deptName: '',
            unitCode: '',
            unitName: '',
            areaYear: this.year,
            sourceType: 4,
            fileType: this.$route.query.classinfoid,
            docId: item.fileList[0].appdocid,
            title: item.title,
            channelId: item.channelId,
            url:
              location.origin +
              '/#/detailsPage' +
              '?id=' +
              item.metaDataId +
              '&areaName=' +
              this.place +
              '&deptname=' +
              item.deptname +
              '&classinfoid=' +
              this.$route.query.classinfoid +
              '&year=' +
              this.year
          })
          .then((res) => {
            // if (res.data.code === 200) {
            // this.listData = res.data.data
          })
      }
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}

ul li {
  list-style: none;
}

.list ul li {
  width: 80%;
  min-height: 50PX;
  background-color: #fff;
  border-bottom: 2PX solid #dfe2e6;
  position: relative;
  margin-top: 14PX;
  font-size: 18PX;
  font-weight: 400;
  color: #161616;
  position: relative;
  cursor: pointer;
}

.list ul li div {
  display: inline-block;
}

.list ul li p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20PX;
}

.dian {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 13PX;
  height: 13PX;
  background: #000000;
  opacity: 0.08;
  border-radius: 50%;
  margin-left: 20PX;
}

.list_txt {
  margin: 0 10px;
  width: 60%;
  margin-left: 45PX;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.list_btn {
  width: 48px;
  background: #1c6493;
  border-radius: 6px;
  line-height: 30px;
  color: #ffffff;
  padding-left: 10PX;
  margin-left: 12%;
}

.first-div .list_btn {
  background: #caa06d !important;
}

.list_time {
  margin-left: 30PX;
}
</style>



// WEBPACK FOOTER //
// src/components/normalList.vue